import React, { Component } from 'react';

export class RejoinOnlineGameForm extends Component {
    static displayName = "Rejoining online session";

  constructor(props) {
      super(props);
      
      this.state = { gameSessionId: props.match.params.gameSessionId, loading: true, statusText: "" };
  }

  componentDidMount() {
      this.rejoinSession();
    }

    rejoinSession = () => {
        fetch('session/rejoin/' + this.state.gameSessionId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(r => {
                if (r.ok) {
                    window.location = '/online-game-board';
                    return;
                }
                this.setState({ loading: false, statusText: "Failed rejoining game: " + r.statusText });
            });
    }

  render() {
    let contents = this.state.loading
        ? <p><em>Loading...</em></p>
        : <p><em>{this.state.statusText}</em></p>;

    return (
      <div>
        {contents}
      </div>
    );
  }
}
